/**
 * 充值套餐静态数据（与 bg_product 1001–1006 一致；支付页以 GET /api/portal/product/list 为准）
 * 1 点数 = 1 字符；千字单价 ≈ price / (quotaAmount / 1000)
 */
export const RECHARGE_PACKAGES = [
  {
    productId: 1001,
    name: '体验版',
    price: 15,
    originalPrice: 25,
    quotaAmount: 5000,
    perThousand: '约3元/千字符',
    badge: '',
    featured: false,
    description: '快速试用，适合单章节小修'
  },
  {
    productId: 1002,
    name: '基础版',
    price: 54,
    originalPrice: 80,
    quotaAmount: 20000,
    perThousand: '约2.7元/千字符',
    badge: '',
    featured: false,
    description: '适合结课小论文/课程报告'
  },
  {
    productId: 1003,
    name: '专业版',
    price: 69.9,
    originalPrice: 120,
    quotaAmount: 30000,
    perThousand: '约2.33元/千字符',
    badge: '80%学生选择',
    featured: true,
    description: '毕业论文/大报告首选规格'
  },
  {
    productId: 1004,
    name: '增强版',
    price: 128,
    originalPrice: 240,
    quotaAmount: 60000,
    perThousand: '约2.1元/千字符',
    badge: '性价比之选',
    featured: false,
    description: '全文反复改稿/多篇连改'
  },
  {
    productId: 1005,
    name: '尊享版',
    price: 288,
    originalPrice: 600,
    quotaAmount: 150000,
    perThousand: '约1.9元/千字符',
    badge: '低至1.9元/千字',
    featured: false,
    description: '多论文拼单/长期储备'
  },
  {
    productId: 1006,
    name: '旗舰版',
    price: 799,
    originalPrice: 2000,
    quotaAmount: 500000,
    perThousand: '约1.6元/千字符',
    badge: '',
    featured: false,
    description: '工作室/实验室批量处理'
  }
]

export const POINTS_RULES = [
  {
    title: '降重复率 / 降AIGC / 润色',
    desc: '每次按实际字符数扣点，不凑整到千字。',
    example: '例：798 字符仅扣 798 点'
  },
  {
    title: '双降',
    desc: '一次任务按字符数 × 倍率扣点。',
    example: '例：798 字符扣 798 × 2 = 1,596 点'
  }
]
